import { render, staticRenderFns } from "./ProjectDeliverable.vue?vue&type=template&id=4944504e&"
import script from "./ProjectDeliverable.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports